import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ashwinidoc from './../../../../assets/images/Doctorsimages/dr.aswini.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'


const AshwiniDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. Ashwini M.R | Best Homeopathy & Cosmetic Doctor in Valasaravakkam Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Ashwini M.R (BHMS, FMC), female homeopathy and cosmetic doctor at H-Cura Multispeciality Clinic, Valasaravakkam, Chennai. Expert in skin, hair, PCOS, chronic illness, holistic care, and nutrition-based treatments near Porur, Alwarthirunagar, and Ramapuram."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Valasaravakkam Chennai, female homeopathy doctor in Chennai, cosmetic doctor in Valasaravakkam, facial aesthetics doctor in Chennai, holistic doctor near Porur and Ramapuram, homeopathy doctor near Alwarthirunagar, female doctor for PCOS in Chennai, nutrition-focused homeopathy doctor in Chennai, homeopathy doctor for acne and pigmentation in Valasaravakkam, natural hair fall treatment doctor in Chennai"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-ashwini-mr-homeopathy-cosmetic-doctor-valasaravakkam-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-ashwini-mr-homeopathy-cosmetic-doctor-valasaravakkam-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });
    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Ashwini_M_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Ashwini M.R</span>
                  <span className="veenadoc-title-credentials">(BHMS, FMC)</span>
                  <span className="veenadoc-title-location">Valasaravakkam, Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Experienced Consultant Doctor at H-Cura Multispeciality Clinic, Valasaravakkam, Chennai, specializing in homeopathy, medical cosmetology, food therapy, and holistic healthcare. Known as one of the best female homeopathy doctors in Chennai who provides natural, safe, and effective treatments for complete well-being.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={ashwinidoc} alt="Dr. Ashwini M.R – Homeopathy & Cosmetic Doctor in Valasaravakkam, Chennai" className="veenadoc-doctor-image" title='Dr. Ashwini M.R | Female Homeopathy & Holistic Doctor in Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Ashwini M.R</h2>
                  <p>
                    Dr. Ashwini M.R (BHMS, FMC) is an experienced and compassionate Consultant Doctor at H-Cura Multispeciality Clinic, Valasaravakkam, Chennai, specializing in homeopathy, medical cosmetology, food therapy, and holistic healthcare. Patients searching for the best homeopathy doctor in Valasaravakkam Chennai, a female homeopathy doctor in Chennai, or a cosmetic doctor in Valasaravakkam near Porur, Alwarthirunagar, and Ramapuram often choose her because of her ability to provide natural, safe, and effective treatments that focus on complete well-being.
                  </p>
                  <p>
                    With her strong medical background, clear communication style, and patient-first philosophy, she has become one of the most trusted doctors at H-Cura Valasaravakkam Chennai.
                  </p>
                </div>

                {/* Educational Background */}
                <div className="veenadoc-article-block">
                  <h2>Educational Background & Training</h2>
                  <p>
                    Dr. Ashwini completed her Bachelor of Homeopathic Medicine and Surgery (BHMS) at Dr. Sivaraj Homoeopathic Medical College and Research Institute, Salem, under Dr. M.G.R Medical University, Chennai, and went on to pursue a Fellowship in Medical Cosmetology (FMC) to expand her expertise in advanced skin and aesthetic treatments.
                  </p>
                  <p>
                    She is also pursuing additional training in Food Therapy and Nutrition, which allows her to combine natural medicine with lifestyle and dietary guidance for long-term results. This combination of homeopathy, cosmetology, and nutrition makes her an ideal choice for patients searching for a holistic doctor in Valasaravakkam who can provide both curative and preventive care.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, FMC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">4+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy, Cosmetology & Nutrition</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Valasaravakkam, Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Clinical Experience */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Experience & Professional Journey</h2>
                  <p>
                    Over the past three years, she has worked in several reputed healthcare centers, including Shruthi Ortho Clinic in Ambur, Dr. Srinivasan Clinic in Korattur, Iswarya Fertility Centre in Adyar, 24 Hours Clinic in Purasaivakkam, and Sugam Homeopathy Clinic in Tambaram. These experiences exposed her to a wide range of patients and conditions, strengthening her ability to treat chronic diseases, women's health concerns, fertility issues, and skin and hair problems.
                  </p>
                  <p>
                    Now, at H-Cura Multispeciality Clinic in Valasaravakkam, she brings this knowledge and experience together to serve the people of Valasaravakkam, Porur, Alwarthirunagar, Ramapuram, and surrounding Chennai areas.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Ashwini has gained recognition as a trichology doctor in Chennai specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                {/* Chronic Conditions Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic Conditions</h2>
                  <p>
                    Her specializations cover a wide range of conditions. Patients consult her for chronic illnesses such as asthma, arthritis, thyroid disorders, migraines, diabetes complications, digestive issues, and hypertension. She is also highly sought after for women's health concerns including PCOS, infertility, hormonal imbalances, and menopause-related issues.
                  </p>
                  <p>
                    Many patients searching for a female homeopathy doctor for PCOS in Chennai or a homeopathy doctor for infertility in Valasaravakkam find her approach safe, effective, and holistic.
                  </p>
                </div>

                {/* Cosmetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Leading Cosmetic & Facial Aesthetics Doctor</h2>
                  <p>
                    In addition to homeopathy, Dr. Ashwini is known as a cosmetic and facial aesthetics doctor in Valasaravakkam Chennai. She offers treatments for acne, scars, pigmentation, wrinkles, and skin rejuvenation using both homeopathy and cosmetology techniques. Patients searching online for a cosmetic doctor near Porur and Ramapuram or a facial aesthetics specialist in Valasaravakkam often visit her for safe and natural solutions that improve skin health and appearance.
                  </p>
                  <p>
                    Her fellowship in cosmetology allows her to deliver advanced treatments for anti-aging, skin brightening, acne scar correction, and pigmentation control, ensuring that patients achieve visible results without side effects.
                  </p>
                </div>

                {/* Hair Care Solutions */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Hair Care & Trichology</h2>
                  <p>
                    Her expertise also extends to hair care and trichology. With an increasing number of patients searching for a homeopathy doctor for hair fall in Valasaravakkam Chennai or a natural hair fall treatment near Alwarthirunagar, Dr. Ashwini provides individualized treatment plans for dandruff, scalp issues, hair thinning, and chronic hair loss.
                  </p>
                  <p>
                    By combining homeopathy remedies with nutrition advice, she ensures that patients experience not just temporary relief but also long-term improvement in hair health.
                  </p>
                </div>

                {/* Nutrition Integration */}
                <div className="veenadoc-article-block">
                  <h2>Food Therapy & Nutrition Integration</h2>
                  <p>
                    What makes her practice unique is her integration of food therapy and nutrition into homeopathy and cosmetology. In today's world, where lifestyle diseases like diabetes, obesity, and hypertension are on the rise, patients are increasingly searching for a nutrition-focused homeopathy doctor in Valasaravakkam Chennai.
                  </p>
                  <p>
                    Dr. Ashwini provides dietary counseling along with natural remedies, helping patients adopt healthier lifestyles that complement their medical treatment. This approach has proven especially effective for patients with metabolic disorders, hormonal conditions, and skin and hair problems.
                  </p>
                </div>

                {/* Women's Health */}
                <div className="veenadoc-article-block">
                  <h2>Women's Health & PCOS Specialist</h2>
                  <p>
                    Dr. Ashwini has established herself as a trusted female doctor for women's health issues in Chennai. She specializes in treating PCOS, infertility, hormonal imbalances, irregular menstrual cycles, and menopause-related concerns using natural homeopathic remedies combined with lifestyle modifications.
                  </p>
                  <p>
                    Many women searching for a female doctor for PCOS in Chennai or natural treatment for hormonal issues find her holistic approach both effective and comfortable, as she understands the unique health challenges women face.
                  </p>
                </div>

                {/* H-Cura Integration */}
                <div className="veenadoc-article-block">
                  <h2>Part of H-Cura Multispeciality Excellence</h2>
                  <p>
                    At H-Cura Multispeciality Clinic Valasaravakkam, she is part of a larger team offering integrated healthcare, including homeopathy, skin care, dental care, and holistic treatments. Many patients looking for the best homeopathy clinic in Valasaravakkam Chennai choose H-Cura because of doctors like Dr. Ashwini, who combine traditional homeopathy with modern innovations like cosmetology and nutrition.
                  </p>
                  <p>
                    Patients searching for female doctor for acne treatment in Chennai, homeopathy doctor for pigmentation in Valasaravakkam, cosmetic doctor near Porur, holistic doctor near Ramapuram, or natural PCOS treatment in Chennai often find her profile relevant to their needs.
                  </p>
                </div>

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block">
                  <h2>Philosophy of Care & Patient Approach</h2>
                  <p>
                    Her philosophy of care reflects her patient-first mindset: "Approaching patients with clear communication and coordinating care to meet their individual needs and values, ensuring in every way that my knowledge will benefit the patient towards wellness." She is known for her approachable nature and her ability to explain every step of treatment clearly, making patients feel comfortable, confident, and cared for.
                  </p>
                  <p>
                    Whether it is managing chronic pain through homeopathy, helping women regulate hormonal cycles naturally, treating skin conditions with cosmetology, or guiding patients toward healthier lifestyles through food therapy, she offers a comprehensive care model that is unique in Chennai.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Community Impact</h2>
                  <p>
                    Her reputation continues to grow as she helps patients not only recover from diseases but also improve their overall quality of life. For those who want safe, non-invasive, and effective healthcare, she is quickly becoming one of the most recognized names in Valasaravakkam and nearby areas like Porur, Alwarthirunagar, and Ramapuram.
                  </p>
                  <p>
                    By consulting Dr. Ashwini M.R at H-Cura Multispeciality Clinic in Valasaravakkam Chennai, patients are choosing a doctor who values empathy, communication, and holistic healing. They are not just receiving medical treatment but also entering into a long-term partnership with a doctor who listens, understands, and guides them toward better health.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Ashwini M.R for Holistic Healthcare</h2>
                  <p>
                    For patients in Valasaravakkam, Porur, Alwarthirunagar, Ramapuram, Tambaram, and surrounding Chennai localities, she is emerging as one of the best female homeopathy and cosmetic doctors in Chennai. Her growing reputation is built on compassion, professionalism, and her ability to blend traditional and modern approaches for long-lasting results.
                  </p>
                  <p>
                    For those searching for a homeopathy doctor near me in Valasaravakkam, cosmetic doctor in Chennai, female doctor for skin and hair problems, holistic doctor in Ramapuram, or a trusted homeopathy doctor for PCOS in Chennai, Dr. Ashwini M.R at H-Cura Multispeciality Clinic is the right choice for safe, effective, and compassionate healthcare.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide natural, side-effect-free treatments that not only cure diseases but also improve lifestyle, confidence, and emotional wellness. With her expertise and dedication, she continues to transform patient care in Chennai, making holistic healthcare accessible to all.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Approaching patients with clear communication and coordinating care to meet their individual needs and values"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Ashwini M.R's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root cause of illness. This patient-centric approach has positioned her among the best holistic homeopathy doctors in Chennai, where she provides customised treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Multispeciality Clinic</h4>
                      <p>Valasaravakkam, Chennai</p>
                      <p>Serving Porur, Alwarthirunagar, Ramapuram</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Ashwini's personalized approach combining homeopathy, cosmetology, and nutrition.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>

    </>
  )
}

export default AshwiniDoc
